import React from "react";

import "./style.scss";
import { msToDaysHours } from "../../../util/date-formatter";

type DueDateCardProps = {
  dueDate: string;
  product: string;
};
const DueDateCard: React.FC<DueDateCardProps> = ({ dueDate, product }) => {
  return (
    <div className="due-date-card-container">
      <div className="due-date-card-header">
        <div className="due-date-card-header-left">
          <div className="due-date-card-header-title">Delivery Days</div>
          <div className="due-date-card-header-product">{product}</div>
        </div>
        <div>
          <svg
            width="59"
            height="56"
            viewBox="0 0 59 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M29.6104 4.37451C24.6658 4.37451 19.8323 5.84074 15.7211 8.58777C11.6099 11.3348 8.40556 15.2393 6.51337 19.8074C4.62118 24.3756 4.1261 29.4022 5.09073 34.2518C6.05536 39.1013 8.43638 43.5559 11.9327 47.0522C15.429 50.5485 19.8836 52.9295 24.7331 53.8941C29.5826 54.8588 34.6093 54.3637 39.1774 52.4715C43.7456 50.5793 47.6501 47.375 50.3971 43.2638C53.1441 39.1525 54.6104 34.319 54.6104 29.3745C54.603 22.7464 51.9667 16.3918 47.2799 11.705C42.5931 7.01815 36.2385 4.38186 29.6104 4.37451ZM29.6104 48.8189C25.7646 48.8189 22.0052 47.6786 18.8076 45.542C15.61 43.4054 13.1177 40.3686 11.646 36.8156C10.1743 33.2626 9.78927 29.3529 10.5395 25.5811C11.2898 21.8092 13.1417 18.3446 15.8611 15.6252C18.5804 12.9059 22.0451 11.054 25.8169 10.3037C29.5888 9.55342 33.4984 9.93848 37.0514 11.4102C40.6044 12.8819 43.6412 15.3741 45.7778 18.5718C47.9144 21.7694 49.0548 25.5288 49.0548 29.3745C49.0493 34.5298 46.9989 39.4724 43.3536 43.1177C39.7082 46.7631 34.7656 48.8134 29.6104 48.8189ZM45.3511 29.3745C45.3511 30.1112 45.0584 30.8178 44.5375 31.3387C44.0166 31.8596 43.31 32.1523 42.5733 32.1523H29.6104C28.8736 32.1523 28.1671 31.8596 27.6462 31.3387C27.1252 30.8178 26.8326 30.1112 26.8326 29.3745V16.4115C26.8326 15.6748 27.1252 14.9683 27.6462 14.4474C28.1671 13.9264 28.8736 13.6338 29.6104 13.6338C30.3471 13.6338 31.0536 13.9264 31.5745 14.4474C32.0955 14.9683 32.3881 15.6748 32.3881 16.4115V26.5967H42.5733C43.31 26.5967 44.0166 26.8894 44.5375 27.4103C45.0584 27.9313 45.3511 28.6378 45.3511 29.3745Z"
              fill="#268D60"
            />
          </svg>
        </div>
      </div>
      <div
        className="due-date-card-body"
        style={{
          fontSize: 80,
          paddingLeft: 45,
          paddingRight: 45,
          justifyContent: "space-between",
          fontFamily: "digital",
        }}
      >
        <div className="due-date-card-date">
          {msToDaysHours(Number(dueDate)).days}
        </div>
        <div>:</div>
        <div className="due-date-card-hour">
          {msToDaysHours(Number(dueDate)).hours}
        </div>
      </div>
      <div
        className="due-date-card-footer"
        style={{ paddingLeft: 45, paddingRight: 45 }}
      >
        <div className="due-date-card-footer-date">Days</div>
        <div className="due-date-card-footer-hour">Hours</div>
      </div>
    </div>
  );
};

export default DueDateCard;
